import { Component, Input } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { LocLabel } from '../../clickable-row-table/models/data-table-config.models';

// ? https://stackblitz.com/edit/angular-star-rating-example?file=src%2Fapp%2FStarRating%2Fstar-rating.module.ts

type StarClass = Record<'star-gray' | 'star-gold' | 'star-hover', boolean>;

@Component({
  selector: 'app-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.scss']
})
export class StarRatingComponent implements ControlValueAccessor {
  @Input() labelKey: string | LocLabel | null | undefined;
  @Input() range: number = 5;
  @Input() disabled = false;
  @Input() padded = true;
  @Input() canBeReassigned = true;

  private _value: any;

  public starClasses: StarClass[] = [];

  constructor(public ngControl: NgControl) {
    ngControl.valueAccessor = this;
  }

  // this method sets the value programmatically
  public writeValue(value: any) {
    if (value !== this._value) {
      this._value = value;
      this.selectStar(value);
    }
  }

  get value(): any {
    return this._value;
  }

  set value(value: any) {
    this.writeValue(value);
    this.onChange(value);
    this.onTouch(value);
  }

  // upon UI element value changes, this method gets triggered
  public registerOnChange(fn: any) {
    this.onChange = fn;
  }

  // upon touching the element, this method gets triggered
  public registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  public onChange: any = (value: any) => (this.value = value);
  public onTouch: any = () => {};

  private selectStar(value: number): void {
    if (this.canBeReassigned || !this.value) {
      this.starClasses = Array.from({ length: this.range }, (_, i) => {
        return {
          'star-gold': i + 1 <= value,
          'star-gray': i + 1 > value,
          'star-hover': this.canBeReassigned
        };
      });
    }
  }
}
